import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'

import { accountsClient, placesClient } from '../../../../utils/apollo/api'
import {
  PLACE_FIELD_VALUES_QUERY,
  USER_FIELD_VALUES_QUERY,
  fetchUserContractFieldValuesWithToken,
  mergeUserFieldValues
} from '../../../serviceOrders/executionV2/_requests/fetchAutofillValue'

export const useAutofillFieldValues = (placeId, userId, sessionTokenForAutofill) => {
  const { data: placeData } = useQuery(PLACE_FIELD_VALUES_QUERY, {
    variables: { id: placeId },
    client: placesClient,
    skip: !placeId,
    fetchPolicy: 'cache-first'
  })

  const { data: userData } = useQuery(USER_FIELD_VALUES_QUERY, {
    variables: { id: userId },
    client: accountsClient,
    skip: !userId || !!sessionTokenForAutofill,
    fetchPolicy: 'cache-first'
  })

  const [userFieldValuesFromToken, setUserFieldValuesFromToken] = useState([])

  useEffect(() => {
    if (!sessionTokenForAutofill || !userId) {
      setUserFieldValuesFromToken([])
      return
    }
    let cancelled = false
    fetchUserContractFieldValuesWithToken(sessionTokenForAutofill, userId).then(fieldValues => {
      if (!cancelled) setUserFieldValuesFromToken(fieldValues)
    })
    return () => { cancelled = true }
  }, [sessionTokenForAutofill, userId])

  const userFieldValues =
    sessionTokenForAutofill && userId
      ? userFieldValuesFromToken
      : mergeUserFieldValues(userData?.user ?? null)

  return React.useMemo(
    () => ({
      placeFieldValues: placeData?.place?.fieldValues ?? [],
      userFieldValues
    }),
    [placeData?.place?.fieldValues, userFieldValues]
  )
}
